import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getAllBooks } from "../utils/bookUtils";
import { handleImgError } from "../utils/thumbnailUtils";
import { PageSEO } from "../hooks/useSEO";
import "../styles/styles.css";

const BookCard = ({ book }) => {
  const navigate = useNavigate();
  return (
    <div className="content-card" onClick={() => navigate(`/books/${book.id}`)}>
      <div className="card-poster">
        <img src={book.thumbnail} alt={book.title} onError={(e) => handleImgError(e, book.title, 400, 560)} />
        <div className="card-overlay">
          <div className="card-overlay-info">
            <span className="card-badge">{book.pages} págs.</span>
            <span className="card-badge">{book.genre[0]}</span>
          </div>
        </div>
      </div>
      <div className="card-info">
        <h3 className="card-title">{book.title}</h3>
        <p className="card-meta">{book.author}</p>
      </div>
    </div>
  );
};

const Books = () => {
  const [allBooks, setAllBooks] = useState([]);
  const [filteredBooks, setFilteredBooks] = useState([]);
  const [selectedGenre, setSelectedGenre] = useState("");

  useEffect(() => {
    const books = getAllBooks();
    setAllBooks(books);
    setFilteredBooks(books);
  }, []);

  useEffect(() => {
    if (!selectedGenre) {
      setFilteredBooks(allBooks);
    } else {
      setFilteredBooks(allBooks.filter((b) => b.genre.includes(selectedGenre)));
    }
  }, [selectedGenre, allBooks]);

  const allGenres = [...new Set(allBooks.flatMap((b) => b.genre))];
  const featured = [...allBooks].sort((a, b) => b.popularity - a.popularity).slice(0, 1)[0];

  return (
    <div className="catalog-page">
      <PageSEO
        title="Biblioteca IA — Libros"
        description="Lee libros originales escritos con inteligencia artificial. Ciencia ficción, filosofía, romance y más géneros — solo en AIVEO."
        url="/books"
      />
      {/* Hero */}
      {featured && (
        <div className="catalog-hero" style={{ backgroundImage: `url(${featured.thumbnail})` }}>
          <div className="hero-overlay" />
          <div className="hero-content">
            <span className="hero-badge">📚 Libro Destacado</span>
            <h1 className="hero-title">{featured.title}</h1>
            <p className="hero-synopsis">{featured.synopsis.slice(0, 120)}...</p>
            <button className="btn-primary" onClick={() => window.location.href = `/books/${featured.id}`}>
              Leer Ahora
            </button>
          </div>
        </div>
      )}

      <div className="content-wrapper">
        <div className="catalog-header">
          <h2 className="section-title">📚 Biblioteca IA</h2>
          <div className="genre-tabs">
            <button
              className={`genre-tab ${!selectedGenre ? "active" : ""}`}
              onClick={() => setSelectedGenre("")}
            >
              Todos
            </button>
            {allGenres.map((g) => (
              <button
                key={g}
                className={`genre-tab ${selectedGenre === g ? "active" : ""}`}
                onClick={() => setSelectedGenre(g)}
              >
                {g}
              </button>
            ))}
          </div>
        </div>

        <div className="content-grid">
          {filteredBooks.map((book) => (
            <BookCard key={book.id} book={book} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Books;
